import axios from '@/libs/api.request'

export const getWorkflowStatesHistories = (workflowName, query) => {
  return axios.request({
    url: `workflow/${workflowName}/histories`,
    method: 'get',
    data: query
  })
}

export const getWorkflowTransitions = (workflowName) => {
  return axios.request({
    url: `workflow/${workflowName}/transitions`,
    method: 'get'
  })
}

export const createWorkflowUserTransitions = (workflowName, modelType, modelId, transitions) => {
  return axios.request({
    url: `workflow/${workflowName}/user-transitions`,
    method: 'post',
    data: { model_type: modelType, model_id: modelId, transitions: transitions }
  })
}

export const createWorkflowUserTransition = (workflowName, modelType, modelId, data) => {
  return axios.request({
    url: `workflow/${workflowName}/user-transition`,
    method: 'post',
    data: { model_type: modelType, model_id: modelId, transition: data.transition, user_id: data.userId, context: data.context }
  })
}

export const getWorkflowUserTransitions = (workflowName, modelType, modelId) => {
  return axios.request({
    url: `workflow/${workflowName}/user-transitions`,
    method: 'get',
    params: { model_type: modelType, model_id: modelId }
  })
}

export const updateWorkflowUserTransition = (workflowName, id, transition) => {
  return axios.request({
    url: `workflow/${workflowName}/user-transitions/${id}`,
    method: 'put',
    data: transition
  })
}

export const removeWorkflowUserTransition = (workflowName, id) => {
  return axios.request({
    url: `workflow/${workflowName}/user-transitions/${id}`,
    method: 'delete'
  })
}

export const applyWorkflowUserTransition = (workflowName, { transition, modelType, modelId, context = {} }) => {
  let data = { transition: transition, model_type: modelType, model_id: modelId }
  if (Object.keys(context).length > 0) {
    data['context'] = context
  }

  return axios.request({
    url: `workflow/${workflowName}/transitions/apply`,
    method: 'post',
    data: data
  })
}

export const processDingtalkRequest = (workflowModelType, workflowModelId, approvalName) => {
  let data = { workflowModelType, workflowModelId, approval_name: approvalName }
  return axios.request({
    url: `integration/dingtalk/process-request`,
    method: 'post',
    data: data
  })
}

export const autoSendDingtalkApprovalRequest = (workflowTransitionId, approvalName) => {
  let data = { workflowTransitionId, approvalName }
  return axios.request({
    url: `integration/dingtalk/auto-send-oa-instance`,
    method: 'post',
    data
  })
}

export const getDingtalkLastRemindDates = (workflowModelType, workflowModelId, approvalName) => {
  return axios.request({
    url: `integration/dingtalk/${workflowModelType}/${workflowModelId}/last-remind-dates`,
    method: 'get'
  })
}
